import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'productShopPanel',
    serviceName: 'grapghql',
    query: gql`
      query productShopPanel($ids: [String], $for_admin: Int) {
        productShopPanel(ids: $ids, for_admin: $for_admin) {
          data {
            attributes {
              values {
                id
                price_change_value
              }
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'createAttributeValueProductShopTotality',
    serviceName: 'shopadmin',
    query: gql`
      mutation createAttributeValueProductShopTotality(
        $attribute_value_product_shop_items: [AttributeValueProductShopInput]!
      ) {
        createAttributeValueProductShopTotality(
          attribute_value_product_shop_items: $attribute_value_product_shop_items
        ) {
          messages
        }
      }
    `,
  },
  delete: {
    name: 'deleteAttributeValueProductShopTotality',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteAttributeValueProductShopTotality($product_shop_id: String!) {
        deleteAttributeValueProductShopTotality(product_shop_id: $product_shop_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
